import type { IconSvgObject } from './types';

const ThreeDViewIcon: IconSvgObject = [
  ["path", { d: "M17 9L12 6.5L7 9M17 9L12 11.5M17 9V15L12 17.5M12 11.5L7 9M12 11.5V17.5M7 9V15L12 17.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V8.5M15.5 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V8.5M15.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V15.5M8.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ThreeDViewIcon;
